export const HOMEPAGE_URL = '/';
export const DISCLOSURE_FORM_URL = '/submit-case';
export const DISCLOSURE_FOLLOW_CASE_URL = '/follow-case';
export const DISCLOSURE_DETAILS_URL = '/disclosure';
